import {
  GetVehiclePartQueryParamsType,
  GetVehiclePartQueryResponseType,
} from '@/common/queries/selections/getVehiclePart/getVehiclePartQuery.type';
import { fetchApi } from '@/config/axiosSetting';

export const getVehiclePartFunction = (
  params: GetVehiclePartQueryParamsType,
): Promise<GetVehiclePartQueryResponseType[]> => {
  return fetchApi.get('selection_item/vehicle_part/wop_list/', {
    params: {
      side: params.side?.id,
      vehicle_type: params.vehicleType,
    },
  });
};
